"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _MdErrorOutline = require("@react-icons/all-files/md/MdErrorOutline");

var _get = _interopRequireDefault(require("lodash/get"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _getFormMethods2 = _interopRequireDefault(require("../Form/getFormMethods"));

var _FileInput = require("./FileInput.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FileInput = function FileInput(props) {
  var accept = props.accept,
      acceptLabel = props.acceptLabel,
      className = props.className,
      disabled = props.disabled,
      error = props.error,
      id = props.id,
      multiple = props.multiple,
      maxLength = props.maxLength,
      _onBlur = props.onBlur,
      _onChange = props.onChange,
      readOnly = props.readOnly,
      theme = props.theme,
      validations = props.validations;

  var _getFormMethods = (0, _getFormMethods2["default"])({
    mode: 'onBlur'
  }),
      errors = _getFormMethods.errors,
      register = _getFormMethods.register,
      setValue = _getFormMethods.setValue;

  var fieldErrors = error || errors[id];

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      fileList = _useState2[0],
      setFileList = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      focus = _useState4[0],
      setFocus = _useState4[1];

  var filled = !!fileList.length > 0 && fileList[0].name !== '' ? 'filled' : '';
  var focusOrFilled = focus || filled;
  var required = (0, _get["default"])(validations, 'required');
  var _theme$textInput$show = theme.textInput.showErrorIcon,
      showErrorIcon = _theme$textInput$show === void 0 ? true : _theme$textInput$show;
  /* This clears the currently selected file when an error occurs
    This reflex forces the user to reselect the file when the previous file is invalid
    That makes sure any submitted file is the current version.
    FileReader has an issue where if a file has been modified since the file input was changed, it cannot read the file.
    Note: if react-hook-forms validation is used the user may not see their file as selected until it passes validation.
  */

  (0, _react.useEffect)(function () {
    if (fieldErrors) {
      setValue(id, null);
      setFileList([]);
    }
  }, [fieldErrors, id, setValue, setFileList]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FileInput.StyledFileInputContainer, {
    className: "".concat(className, " ").concat(fieldErrors ? 'error' : ''),
    disabled: disabled,
    focus: focus,
    readOnly: readOnly
  }, /*#__PURE__*/_react["default"].createElement(_FileInput.StyledFileInputLabel, {
    disabled: disabled,
    focusOrFilled: focusOrFilled,
    htmlFor: id
  }, "Upload File", required && /*#__PURE__*/_react["default"].createElement(_FileInput.StyledFileInputRequired, {
    disabled: disabled
  }, "*")), acceptLabel && /*#__PURE__*/_react["default"].createElement(_FileInput.StyledFileInputTypesLabel, {
    disabled: disabled,
    focusOrFilled: focusOrFilled,
    htmlFor: id
  }, "(The only file type(s) accepted are ".concat(acceptLabel, ".)")), /*#__PURE__*/_react["default"].createElement(_FileInput.StyledFileInputText, {
    disabled: disabled,
    filled: filled,
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement(_FileInput.StyledFileInputChooseButton, {
    htmlFor: id
  }, "Choose file"), fileList.length ? fileList.map(function (file) {
    return file.name;
  }).join(',') : 'no file selected'), /*#__PURE__*/_react["default"].createElement(_FileInput.StyledFileInputObject, {
    accept: accept,
    className: filled,
    disabled: disabled,
    id: id,
    maxLength: maxLength,
    multiple: multiple,
    name: id,
    onClick: function onClick() {
      // This helps guarantee that the selected file is up to date
      // Even if it is the same as the current file
      setValue(id, null);
    },
    onBlur: function onBlur(e) {
      _onBlur(e);

      setFocus(false);
    },
    onChange: function onChange(e) {
      _onChange(e);

      setValue(id, e.target.files);
      setFileList((0, _toConsumableArray2["default"])(e.target.files));
    },
    onFocus: function onFocus() {
      return setFocus(true);
    },
    readOnly: readOnly,
    ref: register(validations),
    type: "file"
  }), showErrorIcon && fieldErrors && /*#__PURE__*/_react["default"].createElement(_FileInput.StyledAlertIconContainer, null, /*#__PURE__*/_react["default"].createElement(_MdErrorOutline.MdErrorOutline, null))), fieldErrors && /*#__PURE__*/_react["default"].createElement(_FileInput.StyledFileInputError, null, fieldErrors.message));
};

FileInput.defaultProps = {
  accept: '',
  acceptLabel: '',
  className: '',
  disabled: false,
  error: undefined,
  multiple: false,
  maxLength: null,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  readOnly: false,
  validations: null
};
FileInput.propTypes = {
  /** CSV of File types for the input to accept */
  accept: _propTypes.string,

  /** Display text of File types to show on the label */
  acceptLabel: _propTypes.string,

  /** Apply custom class name to the container */
  className: _propTypes.string,

  /** Sets file input disabled state */
  disabled: _propTypes.bool,

  /** For passing external errors to the component */
  error: (0, _propTypes.shape)({
    message: _propTypes.string
  }),

  /** Input field unique identifier */
  id: _propTypes.string.isRequired,

  /** Maximum number of characters allowed on the field */
  maxLength: _propTypes.number,

  /** Whether multiple files are allowed to be selected */
  multiple: _propTypes.bool,

  /** Function to be called when focus is removed from the file input */
  onBlur: _propTypes.func,

  /** Function to be called when the file input value is changed */
  onChange: _propTypes.func,

  /** Sets file input readonly state */
  readOnly: _propTypes.bool,

  /** Theme object. Passed automatically by the ThemeProvider high-order component */
  theme: (0, _propTypes.shape)({}).isRequired,

  /** Validations to be provided for the component. */
  validations: (0, _propTypes.shape)({
    required: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
    validate: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  })
};
FileInput.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FileInput",
  "props": {
    "accept": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "CSV of File types for the input to accept",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "acceptLabel": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Display text of File types to show on the label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Apply custom class name to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets file input disabled state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "For passing external errors to the component",
      "type": {
        "name": "shape",
        "value": {
          "message": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "multiple": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether multiple files are allowed to be selected",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "maxLength": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Maximum number of characters allowed on the field",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "onBlur": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Function to be called when focus is removed from the file input",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Function to be called when the file input value is changed",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "readOnly": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets file input readonly state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "validations": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Validations to be provided for the component.",
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "union",
            "value": [{
              "name": "bool"
            }, {
              "name": "string"
            }],
            "required": false
          },
          "validate": {
            "name": "union",
            "value": [{
              "name": "shape",
              "value": {}
            }, {
              "name": "func"
            }],
            "required": false
          }
        }
      },
      "required": false
    },
    "id": {
      "description": "Input field unique identifier",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(FileInput);

exports["default"] = _default;